<script setup lang="ts">
import { AisClearRefinements, AisStateResults } from 'vue-instantsearch/vue3/es'
</script>

<template>
    <ais-clear-refinements class="bg-base-200 flex items-center gap-6 pl-4 pr-2 justify-between h-12 border-b md:hidden">
        <template #default="{ canRefine, refine }">
            <ais-state-results class="flex flex-col gap-4">
                <template #default="{ nbHits }">
                    <span class="text-base-content-subtle text-sm">{{ nbHits }} {{ $t('product.listing.filter.results') }}</span>
                </template>
            </ais-state-results>

            <button
                v-if="canRefine"
                type="button"
                class="btn btn-xs btn-ghost underline text-base-content-subtle"
                @click="refine"
            >
                {{ $t('product.listing.filter.resetFilter') }}
            </button>
        </template>
    </ais-clear-refinements>
</template>
